import { render, staticRenderFns } from "./AddAttendance.vue?vue&type=template&id=32cf203b&"
import script from "./AddAttendance.vue?vue&type=script&lang=js&"
export * from "./AddAttendance.vue?vue&type=script&lang=js&"
import style0 from "./AddAttendance.vue?vue&type=style&index=0&id=32cf203b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports